export default {"src":"/_next/static/media/truck.53bf1ef9.svg","height":512,"width":512};